// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import taskMemberEntity from './entities/task-member.json';
import taskMemberMenu from '../pages/task-member/menu.json';
import taskMemberFullForm from '../pages/task-member/forms/full.json';
import taskMemberContextForm from '../pages/task-member/forms/context.json';
import taskMemberMiniForm from '../pages/task-member/forms/mini.json';
import taskMemberLookupForm from '../pages/task-member/forms/lookup.json';
import taskMemberTableView from '../pages/task-member/views/table.json';
import taskMemberCardsView from '../pages/task-member/views/cards.json';
import taskMemberCalendarView from '../pages/task-member/views/calendar.json';
import taskMemberDashboardView from '../pages/task-member/views/dashboard.json';

/** Тип запису «Учасник завдання» зі сторінками пакета: меню, форми та подання з pages/task-member/. */
export const taskMemberDefinition: IRecordTypeDefinition = {
  ...taskMemberEntity,
  views: assembleViewSet({
      table: taskMemberTableView,
      cards: taskMemberCardsView,
      calendar: taskMemberCalendarView,
      dashboard: taskMemberDashboardView,
  }),
  form: taskMemberFullForm,
  forms: { full: taskMemberFullForm, context: taskMemberContextForm, mini: taskMemberMiniForm, lookup: taskMemberLookupForm },
  menu: taskMemberMenu,
} as IRecordTypeDefinition;
